import React from 'react'
// libs
import styled from 'styled-components'
// components
import TableRow from '@mui/material/TableRow'
import { HoverablePopover, Table } from 'components/UI'
// context
import { ApiTokensPageContext } from 'containers/ApiTokens/layers/API'
import { TableManagementContext } from 'containers/Search/layers/BL'
// hooks
import { useSnackbar } from 'notistack'
// themes
import { TableCell } from 'themes/views/tables'
// utils
import moment from 'moment'

// constants
const headers = [
  { id: 'token', sortable: false, left: true, label: 'TOKEN' },
  { id: 'created_at', sortable: false, left: true, label: 'ISSUED AT' }
]

const TokenInput = styled.input`
  cursor: copy;
  border: none;
  outline: none;
  height: 100%;
  background: transparent;
  font-size: 14px;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
`

const ApiTokensTable: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar()

  const { handleSetPage, handleSetPerPage, page, perPage } = React.useContext(TableManagementContext)
  const { data, totalCount, refetch } = React.useContext(ApiTokensPageContext)

  const copyToClipboard = (token) => () => {
    navigator.clipboard.writeText(token)

    enqueueSnackbar('Copied!', {
      variant: 'success',
      autoHideDuration: 1000
    })
  }

  return (
    <Table
      data={data}
      page={page}
      headers={headers}
      perPage={perPage}
      refetch={refetch}
      title='API Tokens'
      totalCount={totalCount}
      onPageChange={handleSetPage}
      onPerPageChange={handleSetPerPage}>
      {({ data }) =>
        data.map(({ id, token, createdAt }) => (
          <TableRow key={id} hover>
            <TableCell>
              <HoverablePopover trigger={<TokenInput onClick={copyToClipboard(token)} value={token} readOnly />}>
                Click to copy
              </HoverablePopover>
            </TableCell>
            <TableCell size={25}>{moment(createdAt).format('DD/MM/YYYY [at] h:mma zz')}</TableCell>
          </TableRow>
        ))
      }
    </Table>
  )
}

export default ApiTokensTable
